// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * WideModal - Standardized wide modal styles for DAMA application
 *
 * These styles create a full-screen overlay with a centered, wide modal content area.
 * Default max-width is 1400px, which provides ample space for data tables and forms.
 */

.wide-modal-overlay {
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 99999;
  overflow: auto;
}

.wide-modal-container {
  padding: 20px;
  min-height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.wide-modal-content {
  width: 100%;
  margin: 0 auto;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}

/* Responsive adjustments */
@media (max-width: 1440px) {
  .wide-modal-container {
    padding: 10px;
  }
}

@media (max-width: 768px) {
  .wide-modal-container {
    padding: 5px;
  }

  .wide-modal-content {
    max-width: 100% !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/WideModal.css"],"names":[],"mappings":"AAAA;;;;;EAKE;;AAEF;EACE,cAAc;EACd,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,6CAA6C;AAC/C;;AAEA,2BAA2B;AAC3B;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/**\n * WideModal - Standardized wide modal styles for DAMA application\n *\n * These styles create a full-screen overlay with a centered, wide modal content area.\n * Default max-width is 1400px, which provides ample space for data tables and forms.\n */\n\n.wide-modal-overlay {\n  display: block;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.7);\n  z-index: 99999;\n  overflow: auto;\n}\n\n.wide-modal-container {\n  padding: 20px;\n  min-height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n}\n\n.wide-modal-content {\n  width: 100%;\n  margin: 0 auto;\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n}\n\n/* Responsive adjustments */\n@media (max-width: 1440px) {\n  .wide-modal-container {\n    padding: 10px;\n  }\n}\n\n@media (max-width: 768px) {\n  .wide-modal-container {\n    padding: 5px;\n  }\n\n  .wide-modal-content {\n    max-width: 100% !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
